/* eslint-disable */
export default {
  inAMeeting: '会議中',
  onMyWay: '移動中です',
  callMeBackIn: '折り返しお電話ください...',
  willCallYouBackIn: '折り返しお電話します...',
  hour: '時',
  min: '分',
} as const;

// @key: @#@"inAMeeting"@#@ @source: @#@"In a meeting"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in..."@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in..."@#@
// @key: @#@"hour"@#@ @source: @#@"hour"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
